const AbiEntrySummaryKeys = {
  TITLE: "title",
  TITLE_HEADER: "title-header",
  TITLE_CR_ENTITY: "title-cr-entity",
  TITLE_LINE_ITEMS: "title-line-items",
  TITLE_SUMMARY_SUBMIT: "title-summary-submit",
  MY_REFERENCE_NO: "myReferenceNo",
  FILER_CODE: "filerCode",
  FREIGHT_CHARGES: "freightCharges",
  NAME: "name",
  HEADER: "header",
  CR_ENTITY: "crEntity",
  LINE_ITEMS: "lineItems",
  CREATED_BY: "createdBy",
  CREATED_DATE: "createdDate",
  UPDATED_BY: "updatedBy",
  UPDATED_DATE: "updatedDate",
  SUBMITTED_BY: "submittedBy",
  SUBMITTED_DATE: "submittedDate",
  UPDATE_BUTTON: "updateButton",
  SAVE_BUTTON: "saveButton",
  EDIT_BUTTON: "editButton",
  EDIT_SENT_RECORD: "editSentRecord",
  CLONE_BUTTON: "cloneButton",
  DELETE_BUTTON: "deleteButton",
  LineItemsInfo: {
    TITLE: "lineItemsInfo.title",
    ID: "lineItemsInfo.id",
    HEADER_ID: "lineItemsInfo.headerId",
    CREATED_BY: "lineItemsInfo.createdBy",
    CREATED_DATE: "lineItemsInfo.createdDate",
    UPDATED_BY: "lineItemsInfo.updatedBy",
    UPDATED_DATE: "lineItemsInfo.updatedDate",
    SUBMITTED_BY: "lineItemsInfo.submittedBy",
    SUBMITTED_DATE: "lineItemsInfo.submittedDate",
    VERSION: "lineItemsInfo.version",
  },
  PartyInfo: {
    TITLE: "partyInfo.title",
    ID: "partyInfo.id",
    MANIFEST_HEADER_ID: "partyInfo.manifestHeaderId",
    SHIPMENT_HEADER_ID: "partyInfo.shipmentHeaderId",
    CREATED_BY: "partyInfo.createdBy",
    CREATED_DATE: "partyInfo.createdDate",
    UPDATED_BY: "partyInfo.updatedBy",
    UPDATED_DATE: "partyInfo.updatedDate",
    SUBMITTED_BY: "partyInfo.submittedBy",
    SUBMITTED_DATE: "partyInfo.submittedDate",
    VERSION: "partyInfo.version",
    DOB: "partyInfo.dob",
    NATIONALITY: "partyInfo.nationality",
    GENDER: "partyInfo.gender",
    CREW_TYPE: "partyInfo.crewType",
    PARTY_TYPE:"partyInfo.partyType",
  },
  Validations:{
    CARRIER_CODE_LENGTH: "validations.carrierCodeLength",
    CARRIER_CODE_REGX: "validations.carrierCodeRegx",
    TRIP_NUM_LENGTH: "validations.tripNumLength",
    TRIP_NUM_PREFIX: "validations.tripNumPrefix",
    EXP_ARRIVAL_DATE_TIME: "validations.expArrivalDateValidation",
    ALPHA_NUMERIC_REGX:"validations.alphaNumericRegx",
    ALPHA_NUMERIC_SPACE_REGX: "validations.alphaNumericSpaceRegx",
    NUMERIC_REGX: "validations.numericRegx",
    EMAIL_MAX_LENGTH: "validations.emailMaxLength",
    EMAIL_VALID:"validations.emailValid",
    FAX_VALID:"validations.faxValid",
    MAX_LENGTH:"validations.maxLength11",
    MSGFUN_FOR_AC:"validations.msgfunForAC",
    MSGFUN_FOR_DR:"validations.msgfunForDR",
    MSGFUN_FOR_CL:"validations.msgfunForCL",
    MSGFUN_FOR_MR:"validations.msgfunForMR",
    MSGFUN_FOR_RJ:"validations.msgfunForRJ",
    MSGFUN_FOR_CR:"validations.msgfunForCR",
    MSGFUN_FOR_NEW_REC:"validations.msgfunForNewRec",
    ENTER_VALID_INPUT:"validations.enterValidInput",
    NON_FAST_CARD_USER:"validations.nonFastcardUser",
    ALPHA_NUMERIC_WITH_SPLCHARS:"validations.aplhaNumericWithSplChars",
    ALPHANUMERIC_SPECIAL_CHAR: "validations.alphaNumericSpecialChar",
    ALPHANUMERIC_DASH: "validations.alphaNumericWithDash",
    MAX_LENGTH_255:"validations.maxLength255",
    MAX_LENGTH_11:"validations.maxLength11",
    MAX_LENGTH_12:"validations.maxLength12",
    MAX_LENGTH_15:"validations.maxLength15",
    MAX_LENGTH_19:"validations.maxLength19",
    MAX_LENGTH_23:"validations.maxLength23",
    MAX_LENGTH_25:"validations.maxLength25",
    MAX_LENGTH_30:"validations.maxLength30",
    MAX_LENGTH_35:"validations.maxLength35",
    MAX_LENGTH_40:"validations.maxLength40",
    MAX_LENGTH_50:"validations.maxLength50",
    MAX_LENGTH_254:"validations.maxLength254",
    MAX_LENGTH_100:"validations.maxLength100",
    MAX_LENGTH_10:"validations.maxLength10",
    MAX_LENGTH_17:"validations.maxLength17",
    MAX_LENGTH_18:"validations.maxLength18",
    MAX_LENGTH_9:"validations.maxLength9",
    MAX_LENGTH_60:"validations.maxLength60",
    MIN_LENGTH_10:"validations.minLength10",
    TEMPLATE_NAME_REQUIRE:"validations.templateNameRequire",
    ACE_ID_REQUIRED:"validations.aceIdRequire",
    VIN_REQUIRED:"validations.vinRequire",
    EMAIL_FORMAT:"validations.emailFormat",
    MIN_DRIVER_REQUIRED:"validations.minDriverRequired",
    FAST_CARD_REQUIRE:"validations.fastCardRequired",
    ACE_ID_REQUIRE:"validations.aceIdRequired",
    CITY_NAME_REQUIRE:"validations.cityNameRequired",
    POSTAL_CODE_REQUIRE:"validations.postalCodeRequired",
    STATE_REQUIRE:"validations.stateRequired",
    ADDRESS_1_REQUIRE:"validations.address1Required",
    TRUCK_ID_REQUIRED:"validations.truckIdRequired",
    INVALID_ARRIVAL_DATE_TIME_FORMAT:"validations.arrivalDateTimeFormat",
  }
}

export default AbiEntrySummaryKeys
